import script from "./ModalHelp.vue?vue&type=script&setup=true&lang=js"
export * from "./ModalHelp.vue?vue&type=script&setup=true&lang=js"

import "./ModalHelp.vue?vue&type=style&index=0&id=40443120&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-40443120"]])

export default __exports__